export * from "./product-type-switch.component";
export * from "./product-type-switch.controller";
